module.exports = __webpack_public_path__ + "resources/video-loading.ea3f21d171094c9a.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-text/img/video-loading.png
// module id = 633
// module chunks = 0 1 2 3